import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @author rowilken.btc
     */
    angular
        .module('app')
        .directive('pkpMinMaxLengthValidator', pkpMinMaxLengthValidator);

    function pkpMinMaxLengthValidator() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ctrl) {
                function pkpMinMaxLengthValidator(ngModelValue) {
                    if (!!ngModelValue) {
                        var minLength = attr.minLength;
                        var minLengthError = attr.minLengthError;
                        if (!!minLength && !!minLengthError) {
                            ctrl.$setValidity(
                                minLengthError,
                                ngModelValue.length >= minLength
                            );
                        }

                        var maxLength = attr.maxLength;
                        var maxLengthError = attr.maxLengthError;
                        if (!!maxLength && !!maxLengthError) {
                            ctrl.$setValidity(
                                maxLengthError,
                                ngModelValue.length <= maxLength
                            );
                        }
                    }

                    return ngModelValue;
                }

                ctrl.$parsers.push(pkpMinMaxLengthValidator);
            }
        };
    }
})();
